'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagUzAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 6.66667H28V0H0V6.66667Z",
          fill: "#04AAC8"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V13.3333H0V20Z",
          fill: "#23C840"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4.66667 5.33333C5.07795 5.33333 5.46023 5.20919 5.77809 4.99633C5.74126 4.99876 5.70411 5 5.66667 5C4.74619 5 4 4.25381 4 3.33333C4 2.41286 4.74619 1.66667 5.66667 1.66667C5.70411 1.66667 5.74126 1.6679 5.77809 1.67033C5.46023 1.45748 5.07795 1.33333 4.66667 1.33333C3.5621 1.33333 2.66667 2.22876 2.66667 3.33333C2.66667 4.4379 3.5621 5.33333 4.66667 5.33333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8 4.66667C8 5.03486 7.70152 5.33333 7.33333 5.33333C6.96514 5.33333 6.66667 5.03486 6.66667 4.66667C6.66667 4.29848 6.96514 4 7.33333 4C7.70152 4 8 4.29848 8 4.66667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10 2.66667C10.3682 2.66667 10.6667 2.36819 10.6667 2C10.6667 1.63181 10.3682 1.33333 10 1.33333C9.63181 1.33333 9.33333 1.63181 9.33333 2C9.33333 2.36819 9.63181 2.66667 10 2.66667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.3333 2C13.3333 2.36819 13.0349 2.66667 12.6667 2.66667C12.2985 2.66667 12 2.36819 12 2C12 1.63181 12.2985 1.33333 12.6667 1.33333C13.0349 1.33333 13.3333 1.63181 13.3333 2Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12.6667 5.33333C13.0349 5.33333 13.3333 5.03486 13.3333 4.66667C13.3333 4.29848 13.0349 4 12.6667 4C12.2985 4 12 4.29848 12 4.66667C12 5.03486 12.2985 5.33333 12.6667 5.33333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.6667 4.66667C10.6667 5.03486 10.3682 5.33333 10 5.33333C9.63181 5.33333 9.33333 5.03486 9.33333 4.66667C9.33333 4.29848 9.63181 4 10 4C10.3682 4 10.6667 4.29848 10.6667 4.66667Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagUzAsset = forwardRef(FlagUzAsset);

export { VpFlagUzAsset as default };
